module.exports = __webpack_public_path__ + "static/media/vdcalseyde_cropped.2e1ade3f.png";